const Home = () => {
  return (
    <div>
      <h1>Oops!</h1>
      <h3>
        It looks like you're on a mobile device. This app is not optimized for
        mobile devices. Please use a desktop or laptop computer to access this
        app. Thank you!
      </h3>
    </div>
  );
};

export default Home;
